var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:("hamburger " + _vm.cssStyle)},[_c('div',{staticClass:"bit-1"}),_c('div',{staticClass:"bit-2"}),_c('div',{staticClass:"bit-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }